const AUTH_ERROR_MAP={
    'auth/invalid-email': 'Please enter a valid email address.',
    'auth/user-disabled': 'This account has been disabled. Please contact support.',
    'auth/user-not-found': 'No account found with this email address.',
    'auth/wrong-password': 'Incorrect password. Please try again.',
    'auth/email-already-in-use': 'An account with this email already exists.',
    'auth/weak-password': 'Password must be at least 6 characters.',
    'auth/too-many-requests': 'Too many attempts. Please try again later.',
    'auth/network-request-failed': 'Network error. Please check your connection.',
    'auth/popup-closed-by-user': 'Sign-in was cancelled.',
    'auth/cancelled-popup-request': 'Sign-in was cancelled.',
    'auth/account-exists-with-different-credential': 'An account already exists with the same email but a different sign-in method.',
    'auth/requires-recent-login': 'Please sign in again to complete this action.',
    'auth/invalid-action-code': 'This link has expired or already been used.',
    'auth/expired-action-code': 'This link has expired. Please request a new one.',
    'auth/invalid-credential': 'Invalid credentials. Please try again.',
    'auth/operation-not-allowed': 'This sign-in method is not enabled.',
    'auth/popup-blocked': 'Sign-in popup was blocked. Please allow popups for this site.',
    'auth/credential-already-in-use': 'This credential is already associated with another account.',
    'auth/invalid-login-credentials': 'Invalid email or password. Please try again.',
}

export function getAuthErrorMessage(error) {
    const code=error?.code||''
    return AUTH_ERROR_MAP[code]||'Something went wrong. Please try again.'
}
